import dayjs from 'dayjs'
import { i18nService } from '@accor/customer-vue-services'

i18nService.configure(
  (locale: string) => {
    setDayJsLocale(locale)

    return import(`@/assets/locales/b2c/${locale}.json`)
  },
  {
    supportedLocales: [
      'ar',
      'de',
      'es',
      'fr',
      'en',
      'id',
      'it',
      'ja',
      'ko',
      'nl',
      'pl',
      'pt',
      'pt-br',
      'ru',
      'th',
      'tr',
      'zh',
      'vi'
    ]
  }
)

i18nService.addLocaleLoader((locale: string) => {
  return import(`@/assets/locales/aab/${locale}.json`)
})

const setDayJsLocale = async (locale: string) => {
  try {
    const dayJsLocale = await import(`../../node_modules/dayjs/esm/locale/${locale}.js`)
    dayjs.locale(dayJsLocale)
  } catch {
    console.warn('dayjs locale not loaded')
  }
}

// Keep for now as it is used in e2e tests
export async function loadLocaleMessages(locale: string, messages: object) {
  i18nService.i18n.global.locale = locale
  i18nService.i18n.global.setLocaleMessage(locale, messages)
  await setDayJsLocale(locale)
}
